var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.75 3.5h3.75V5H14v9.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 0 1-.75-.75V5H.5V3.5h3.75V1.25A.75.75 0 0 1 5 .5h6a.75.75 0 0 1 .75.75zM12.5 5h-9v9h9zM5.75 7.25h1.5v4.5h-1.5zm3 0h1.5v4.5h-1.5zM5.75 2v1.5h4.5V2z"
  })));
};
export default SvgDelete;